<template>
  <div>
    <v-file-input
      v-model="image"
      accept="image/*"
      label="Image File"
      show-size
      append-outer-icon="mdi-upload"
      @click:append-outer="uploadImage"
    />
    <!-- translation causes error in tiptap, so we use append-icon above for upload button
    <v-btn @click="uploadImage">
      {{ $t('uploadimage.uploadimage') }}
    </v-btn>
    -->
  </div>
</template>

<script>
  import { createHash } from 'crypto'
  import { uploadFile } from '@/firebase'
  export default {
    name: 'UploadImage',
    data () {
      return {
        image: {},
      }
    },
    methods: {
      uploadImage () {
        if (this.image.name) {
          const reg = /(?:\.([^.]+))?$/
          const ext = reg.exec(this.image.name)[1]
          uploadFile(this.image, 'uploaded_pic/' + createHash('sha256').update(this.image).digest('hex') + '.' + ext)
            .then(url => {
              this.$emit('select-file', { src: url, alt: this.image.name })
            })
            .catch(error => {
              console.log(error)
            })
        }
      },
    },
  }
</script>
